import { connect } from 'react-redux'
import { setConfigurator } from '../../actions'
import Color from './Color'

const mapStateToProps = state => ({
  configurator: state.configurator
})

const mapDispatchToProps = {
  setConfigurator
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Color)
